// extracted by css-extract-rspack-plugin
export default {"pageColumn":"src-pages-Weather-Alerts-module__pageColumn-QtOpLg"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"pageColumn\":\"src-pages-Weather-Alerts-module__pageColumn-QtOpLg\"}";
        // 1791855167156
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  